/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import React, {ReactElement} from 'react';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import BolReturn from '../models/bolReturnModel';

import Image from '../components/misc/image';

import {AccessKey} from './interfaces';

import i18n from '../i18n';

export enum ReturnOptionType {
    DETAILS,
    CREDIT,
    INVOICE,
    CREDIT_INVOICE,
    SEND,
    BOL
}

export type ReturnOption = {
    label: string;
    type: ReturnOptionType;
    icon: ReactElement;
    disabled?: boolean;
    accessKey: AccessKey;
};

export function getReturnOptions(bolReturn: BolReturn): ReturnOption[] {
    const options: ReturnOption[] = [
        {
            label: i18n.t('util.return.details', 'Details'),
            type: ReturnOptionType.DETAILS,
            icon: <AwesomeIcon name='list' className='icon' />,
            accessKey: AccessKey.RETURN_DETAILS
        }
    ];
    if (bolReturn.invoiceId)
        options.push({
            label: i18n.t('util.return.originalInvoice', 'Originele factuur'),
            type: ReturnOptionType.INVOICE,
            icon: <AwesomeIcon name='receipt' className='icon' />,
            accessKey: AccessKey.INVOICE_DETAILS
        });
    if (bolReturn.creditInvoiceId)
        options.push(
            {
                label: i18n.t('util.return.creditInvoice', 'Creditfactuur'),
                type: ReturnOptionType.CREDIT_INVOICE,
                icon: <AwesomeIcon name='euro-sign' className='icon' />,
                accessKey: AccessKey.INVOICE_DETAILS
            },
            {
                label: i18n.t('util.return.sendCreditInvoice', 'Creditfactuur verzenden'),
                type: ReturnOptionType.SEND,
                icon: <AwesomeIcon name='paper-plane' className='icon' />,
                accessKey: AccessKey.RETURN_SEND_CREDIT
            }
        );
    else
        options.push({
            label: i18n.t('util.return.credit', 'Crediteren'),
            type: ReturnOptionType.CREDIT,
            icon: <AwesomeIcon name='euro-sign' className='icon' />,
            accessKey: AccessKey.RETURN_CREATE_CREDIT
        });
    options.push({
        label: i18n.t('util.return.showInBol', 'Weergeven in Bol'),
        type: ReturnOptionType.BOL,
        icon: <Image name='bol-16' className='icon' alt='Bol' />,
        accessKey: AccessKey.RETURN_BOL
    });
    return options;
}
